import type { QueryClient } from "@tanstack/react-query";

export const invalidateOrgQueries = (queryClient: QueryClient) => {
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4OrgReportByOrg" }] });
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4OrgReportOptions" }] });
};
